<template>
  <div class="upload-container">
    <div class="demo-upload-list" v-if="cover">
      <img
        style="width: 58px; height: 58px; vertical-align: middle"
        v-lazy="$global.imgUrl + cover"
        alt=""
      />
      <div class="demo-upload-list-cover">
        <Icon
          type="ios-trash-outline"
          @click.native="$emit('handleUpload', '');"
        ></Icon>
      </div>
    </div>
    <Upload
      v-else
      ref="upload"
      type="drag"
      style="display: inline-block; width: 58px"
      :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
      :headers="{ token: token }"
      :max-size="1024"
      accept=".png, .jpg, .jpeg"
      :format="['jpg', 'jpeg', 'png']"
      :show-upload-list="false"
      :on-success="handleSuccess"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
    >
      <div style="width: 58px; height: 58px; line-height: 58px">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    cover: {
      type: String,
    },
  },
  computed: {
    ...mapState(["token"]),
  },
  methods: {
    handleSuccess(res) {
      this.$emit("handleUpload", res.content.url);
    },
    handleFormatError() {
      this.$Notice.warning({
        title: "上传文件格式错误",
        desc: "封面只能上传pdf,jpg类型文件",
      });
    },
    handleMaxSize() {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: "封面图大小超过1M.",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ivu-upload {
  height: auto;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
</style>
